module.exports = __webpack_public_path__ + "static/media/ibd_neck3.1619d5ad.png";